<template>
  <el-dialog
    :visible.sync="detailsDialog"
    :lock-scroll="false"
    :close-on-click-modal="true"
    :before-close="closeDialog"
    :width="this.$parent.loginType == 1 ? '885px' : '760px'"
    :custom-class="this.$parent.loginType == 1 ? 'eduBox' : ''"
    :modal="false"
    top="25vh"
  >
    <div class="box_con">
      <div class="boxWrap clearfix">
        <!-- <div v-if="this.$parent.loginType==1" class="edu_title">用户登录</div> -->
        <div class="imgBox">
          <img
            :src="this.$parent.login_jyj"
            alt
            v-if="this.$parent.loginType == 1"
            class="edu_img"
          />
          <img
            :src="this.$parent.login_wjw"
            alt
            v-else-if="this.$parent.loginType == 2"
          />
          <!-- <img src="../assets/images/dl_dl_pic3.png" alt v-else /> -->
          <div class="wx_erCode" v-else>
            <h3>各幼儿园登录入口</h3>
            <div class="weixin_wrap">
              <div
                style="
                  color: #373737;
                  position: relative;
                  top: 10px;
                  right: 16px;
                "
              >
                微信扫码 ，轻松登录
              </div>
              <div class="QRcode_box">
                <wxlogin
                  class="wxlogin"
                  :appid="appid"
                  :redirect_uri="redirect_uri"
                  :href="href"
                  :state="state"
                  theme="black"
                  scope="snsapi_login"
                ></wxlogin>
              </div>
              <div class="wx_phone">
                <div style="width: 32px; height: 32px">
                  <img src="../assets/images/img_wxdh.png" alt="" />
                </div>
                <div>13957770018</div>
              </div>
            </div>
          </div>
        </div>
        <div class="loginWrap loginMain" v-if="weixin">
          <form method="post">
            <div class="login_user login_phone">
              <input
                class="user"
                type="text"
                v-model="phone"
                placeholder="请输入手机号"
                @keydown.enter="doPost"
                ref="phone"
              />
            </div>
            <div class="login_user login_pwd">
              <input
                class="pwd"
                type="password"
                v-model="password"
                placeholder="请输入密码"
                @keydown.enter="doPost"
                ref="password"
              />
            </div>
            <div class="login_user login_img">
              <input
                v-model="imgcode"
                class="img icode"
                type="text"
                placeholder="请输入图形验证码"
                @keydown.enter="doPost"
                @click="loadImgcode"
                ref="imgcode"
              />
              <!-- <img id="vercode-img" src="../assets/images/captcha.png" alt /> -->
              <img id="vercode-img" :src="codeUrl" alt @click="refreshCode" />
            </div>
            <div class="login_user login_code" v-if="!Validation">
              <input
                class="code"
                type="text"
                v-model="smscode"
                placeholder="请输入短信验证码"
                @keydown.enter="doPost"
                ref="smscode"
              />
              <a href="javascript:;" class="getCode" @click="getSMSCode">{{
                sendText
              }}</a>
            </div>
            <!-- <a href="" class="modifyPwd">忘记密码？</a> -->
            <a href="javascript:;" @click="doPost()" class="login_btn">登录</a>
            <!-- <p class="login_weixin" @click="loginWeixin">微信二维码登录></p> -->
          </form>
        </div>
        <!-- <div class="loginWrap loginMain" v-else>
          <div class="weixin_wrap">
            <div class="weixin_title">微信登录</div>
            <div class="QRcode_box">
              <wxlogin
                class="wxlogin"
                :appid="appid"
                :redirect_uri="redirect_uri"
                :href="href"
                :state="state"
                theme="black"
                scope="snsapi_login"
              ></wxlogin>
            </div>
            <div class="weixin_bottom">
              <img src="../assets/images/img_wxsm.png" alt="" />
              <p class="weixin_tip">请使用微信扫描二维码登录</p>
            </div>
          </div>
          <p class="user_login" @click="loginWeixin">用户名密码登录></p>
        </div> -->
      </div>
    </div>
  </el-dialog>
</template>

<script>
import qs from "qs";
import wxlogin from "vue-wxlogin";

export default {
  name: "login-dialoig",
  components: { wxlogin },
  data() {
    return {
      codeUrl: "api/user/getlogincaptcha",
      phone: "",
      password: "",
      imgcode: "",
      smscode: "",
      Validation: localStorage.getItem("Validation"),
      sendText: "获取验证码",
      isSend: true,
      totalTime: 60,
      weixin: true,

      appid: "wx82eb702760e3a9d2",
      redirect_uri: "https://www.dzschool.cn/api/WxQrLogin/Callback",
      href: "data:text/css;base64,aWZyYW1lewpoZWlnaHQ6MzAwcHggIWltcG9ydGFudDsKfQoKLnRpdGxlLC5pbmZvewpkaXNwbGF5Om5vbmU7Cn0KLmltcG93ZXJCb3h7CiAgICB0b3A6IDRweDsKICAgIGxlZnQ6IDMycHg7CndpZHRoOiBhdXRvOwp9Ci5pbXBvd2VyQm94IC5xcmNvZGUgewp3aWR0aDoyMDBweCAhaW1wb3J0YW50Owp9Cg==",
      state: "login",
    };
  },
  methods: {
    loginWeixin() {
      this.weixin = !this.weixin;
    },
    refreshCode() {
      var num = Math.ceil(Math.random() * 10);
      this.codeUrl = "api/user/getlogincaptcha?" + num;
    },
    loadImgcode() {
      if (this.codeUrl == "") this.codeUrl = "api/user/getlogincaptcha";
    },
    getSMSCode() {
      if (this.isSend) {
        if (this.phone == "") {
          this.$message.warning("请输入手机号");
          this.$refs.phone.focus();
          return;
        }
        if (this.imgcode == "") {
          this.$message.warning("请输入图形验证码");
          this.$refs.imgcode.focus();
          return;
        }
        // this.sendSuccess();
        this.axios
          .post(
            "api/user/SendCode",
            qs.stringify({ phone: this.phone, captcha: this.imgcode })
          )
          .then((res) => {
            let data = res.data;
            if (data.resultType == 0) {
              this.$message.success(data.message);
              this.sendSuccess();
            } else {
              this.$alert(data.message);
              this.refreshCode();
            }
          })
          .catch((err) => {
            this.$alert("请求失败处理");
          });
      }
    },
    sendSuccess() {
      var ts = this;
      ts.isSend = false;
      var timer = setInterval(function () {
        ts.totalTime -= 1;
        if (ts.totalTime > 0) {
          ts.sendText = ts.totalTime + "s后重新获取";
        } else {
          clearInterval(timer);
          ts.totalTime = 60;
          ts.sendText = "获取验证码";
          ts.isSend = true;
        }
      }, 1000);
    },
    doPost() {
      // this.$alert("data.message", "title", {
      //   callback: function (action, instance) {
      //     if (action == "confirm") console.log("login");
      //   },
      // });
      // return;
      if (this.phone == "") {
        this.$message.warning("请输入手机号");
        this.$refs.phone.focus();
        return;
      }
      if (this.password == "") {
        this.$message.warning("请输入密码");
        this.$refs.password.focus();
        return;
      }
      if (this.smscode == "" && !this.Validation) {
        this.$message.warning("请输入短信验证码");
        this.$refs.smscode.focus();
        return;
      }
      // if (this.$parent.loginType == 1) {
      //   if (this.imgcode == "") {
      //     this.$message.warning("请输入图形验证码");
      //     this.$refs.imgcode.focus();
      //     return;
      //   }
      // } else {
      //   if (this.smscode == "") {
      //     this.$message.warning("请输入短信验证码");
      //     this.$refs.smscode.focus();
      //     return;
      //   }
      // }
      let data = {
        phone: this.phone,
        password: this.password,
        imgcode: this.imgcode,
        smscode: this.smscode,
        loginType: this.$parent.loginType,
        Validation: this.Validation,
      };
      this.axios
        .post("api/user/teacherlogin", qs.stringify(data))
        .then((res) => {
          let data = res.data;
          if (data.resultType == 0) {
            this.$message.success("登录成功!");
            // localStorage.removeItem("userInfo");
            // localStorage.setItem("loginType", this.$parent.loginType);
            // localStorage.setItem("footName", data.appendData.footName);
            // localStorage.setItem(
            //   "loginToken",
            //   "Bearer " + data.appendData.token
            // );
            // localStorage.setItem("tokenExpires",data.appendData.expiresLong);

            localStorage.setItem("loginType", this.$parent.loginType);
            var jwt = data.appendData.jwt;
            localStorage.setItem("footName", jwt.footName);
            localStorage.setItem("loginToken", "Bearer " + jwt.token);
            localStorage.setItem("tokenExpires", jwt.expiresLong);

            var user = data.appendData.user;
            localStorage.setItem("userInfo", user);
            localStorage.setItem("dataToken", user.dataToken);
            localStorage.setItem("schoolGuid", user.kinderGartenGuid);
            localStorage.setItem("Validation", user.validation);

            this.$store.commit("setUser", user);
            this.$store.commit("setV20", user.isV20);

            localStorage.removeItem("placeData");
            // this.$common.resetCriwd();

            // if (user.kinderGartenId == 0 && this.$positionName != "sh") {
            //   this.$router.push("/homepage");
            // }
            this.getSsoApp();
          } else {
            if (data.isVerificationCode != 0) {
              this.Validation = null;
              localStorage.removeItem("Validation");
            }
            this.$alert(data.message);
            this.refreshCode();
          }
        })
        .catch((err) => {
          this.$alert("请求失败处理");
        });
    },
    getSsoApp() {
      this.axios
        .post("api/YYT3PC/Home/GetSsoApp2")
        .then((res) => {
          if (res.data.resultType == 0) {
            localStorage.setItem("SsoApp", JSON.stringify(res.data.appendData));
            this.$parent.loginSuccess();
          }
        })
        .catch((err) => this.$alert(err));
    },
    closeDialog() {
      this.$parent.closeDialog();
    },
  },
  props: {
    detailsDialog: Boolean,
  },
};
</script>

<style scoped lang="less">
.boxWrap {
  position: relative;
  padding: 10px 20px;
  box-sizing: border-box;
}

.imgBox {
  float: left;
  width: 325px;
}

.imgBox img {
  display: block;
  height: 270px;
}

.loginWrap {
  float: right;
  width: 325px;
  padding-top: 18px;
  box-sizing: border-box;
}

.loginMain {
  padding-top: 0;
}

.loginMain .login_user {
  margin-bottom: 20px;
  position: relative;
  border: 1px solid #e5e5e5;

  &:before {
    content: "";
    width: 40px;
    height: 39px;
    position: absolute;
    left: 0;
    top: 0;
    background: transparent url(../assets/images/dl_xtb_yhm.png) 10px center
      no-repeat;
  }
}

.loginMain .login_pwd {
  margin-bottom: 20px;
}

.loginMain .login_phone:before {
  background: url(../assets/images/dl_xtb_yhm.png) 10px center no-repeat;
}

.loginMain .login_pwd:before {
  background: url(../assets/images/dl_xtb_mm.png) 10px center no-repeat;
}

.loginMain .login_img:before {
  /*padding-right: 130px;*/
  background: url(../assets/images/dl_xtb_yzm.png) 10px center no-repeat;
}

.loginMain .login_code:before {
  /*padding-right: 130px;*/
  background: url(../assets/images/dl_xtb_dx.png) 10px center no-repeat;
}

.loginMain .login_user input {
  width: 100%;
  height: 39px;
  line-height: 33px;
  font-size: 14px;
  color: #818181;

  padding: 0 8px 0 40px;
  box-sizing: border-box;
}

/* WebKit browsers 适配谷歌 */
.loginMain .login_user input::-webkit-input-placeholder {
  color: #c8cdd4;
}

/* Mozilla Firefox 4 to 18 适配火狐 */
.loginMain .login_user input:-moz-placeholder {
  color: #c8cdd4;
}

/* Mozilla Firefox 19+ 适配火狐 */
.loginMain .login_user input::-moz-placeholder {
  color: #c8cdd4;
}

/* Internet Explorer 10+  适配ie*/
.loginMain .login_user input:-ms-input-placeholder {
  color: #c8cdd4;
}

.loginMain .login_img {
  position: relative;
}

.loginMain .login_user img {
  width: 88px;
  height: 30px;
  position: absolute;
  right: 4.5px;
  top: 4.5px;
}

.loginMain .login_code {
  position: relative;
}

.loginMain .login_user .getCode {
  display: inline-block;
  min-width: 88px;
  text-align: center;
  height: 27px;
  color: #4cba0e;
  position: absolute;
  right: 8px;
  top: 6px;
  font-size: 14px;
  border-left: 1px solid #e7e7e7;
  line-height: 27px;
  padding-left: 8px;
  box-sizing: border-box;
}

.login_btn {
  display: block;
  width: 100%;
  height: 45px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  line-height: 45px;
  background: #4cba0e;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 28px;
}
.login_weixin {
  text-align: right;
  color: #c8cdd4;
  cursor: pointer;
  padding-top: 8px;
}
.weixin_wrap {
  text-align: center;
  .weixin_title {
    text-align: center;
    color: #47a90f;
    font-weight: 700;
    font-size: 22px;
  }
  .weixin_bottom {
    img {
      width: 17px;
      height: 17px;
      display: inline-block;
      vertical-align: middle;
    }
    .weixin_tip {
      display: inline-block;
    }
  }
}
.user_login {
  text-align: right;
  color: #c8cdd4;
  cursor: pointer;
  padding-top: 8px;
}
.wx_erCode {
  h3 {
    text-align: center;
    font-size: 22px;
    letter-spacing: 3px;
    left: auto;
    color: rgb(71, 169, 15);
    padding-right: 22px;
  }
}
.QRcode_box {
  background: url("../assets/images/img_wxdl_dt.png") no-repeat;
  background-size: 305px 239px;
}
.wxlogin {
  // height: 300px;
  /deep/iframe {
    height: 239px !important;
  }
}
.wx_phone {
  padding-right: 30px;
  img {
    width: 100%;
    height: 100%;
  }
  div {
    display: inline-block;
    color: #47a90f;
    font-weight: 600;
    font-size: 20px;
    vertical-align: middle;
  }
}
/deep/ .el-dialog__header {
  padding: 0;
  height: 0;
  border: 0;
}

/deep/ .el-dialog {
  border-radius: 4px;
}

/deep/ .eduBox {
  padding-left: 451px;
  background: transparent url("../assets/images/img_login_sj.png") no-repeat;
  background-size: 25px 30px;
  background-position: 427px top;
  box-shadow: none;
  position: relative;

  .el-dialog__header {
    background: #fff;
  }

  .el-dialog__body {
    background: #fff;
    height: 400px;
  }

  .boxWrap {
    padding: 0 32px;

    .loginMain .login_user {
      margin-bottom: 25px;
    }

    .login_btn {
      margin-top: 42px;
    }
  }

  .edu_title {
    font-size: 22px;
    color: #47a90f;
    margin-bottom: 22px;
    text-align: center;
  }

  .edu_img {
    position: absolute;
    left: -471px;
    top: -27px;
    width: 451px;
    height: 371px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/LoginDialog.vue